import { render } from "./Overlay.vue?vue&type=template&id=4bd2d493&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=4bd2d493&scoped=true&lang=css"

import exportComponent from "D:\\dev\\vuejs\\nafn\\nafn.urmull.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd2d493"]])

export default __exports__